import { CurrentUserGq } from '../../../../graphql/users/models/CurrentUserGq';
import { FormikErrors, useFormik } from 'formik';
import { ProjectGq } from '../../../../graphql/projects/models/ProjectGq';
import { projectsApiService } from '../../../../graphql/projects/projectsApiService';
import { TranslateFormState } from './TranslateFormState';
import { currencyList } from '../../../../graphql/projects/models/Currencies';
import { DomainTypeGq } from '../../../../graphql/projects/models/DomainTypeGq';
import { GenericSelectOption } from '../../../voxel/Forms/VoxelSelect';
import { useUserDefaults } from '../../../../logic/otherUtilities/useUserDefaults';
import { useProjectDefaults } from '../../../../logic/otherUtilities/useProjectDefaults';
import { globalOption } from '../../Autocomplete/VoxelAutocompleteCountry';

export const protocolOptions: GenericSelectOption[] = [
  { value: 'https://', title: 'https://' },
  { value: 'http://', title: 'http://' },
];

export function useTranslateProjectForm(
  project: ProjectGq,
  onSuccess: (result: ProjectGq) => Promise<void>,
  user: CurrentUserGq
) {
  const mutation = projectsApiService.mutations.translate.useTranslateProject();
  const userDefaults = useUserDefaults(user);
  const projectDefaults = useProjectDefaults(project);

  return useFormik<TranslateFormState>({
    initialValues: {
      oldProjectId: project.id,
      newName: project.name?.length ? `${project.name} (translated)` : 'Translation',
      newClientName: user.team.name ?? project.clientName ?? '',
      newCurrency: currencyList.find((c) => c.code === project.currency),
      fromCountry: projectDefaults.volumeCountry,
      fromCity: projectDefaults.volumeCity,
      fromLanguage: projectDefaults.volumeLanguage,
      newCountry: userDefaults.volumeCountry,
      newCity: userDefaults.volumeCity,
      newLanguage: userDefaults.volumeLanguage,
      newDomain: { protocol: protocolOptions[0].value, domain: project.domains?.find((d) => d.type === DomainTypeGq.PROJECT)?.hostName ?? '', type: DomainTypeGq.PROJECT },
      serpCountry: projectDefaults.volumeCountry,
      serpCity: projectDefaults.volumeCity,
    },
    validate: (values) => {
      const errors: FormikErrors<any> = {};
      if (!values.newName.length) {
        errors.newName = 'Required';
      }
      if (!values.newClientName.length) {
        errors.newClientName = 'Required';
      }
      if (!values.newLanguage?.name?.length) {
        errors.newLanguage = 'Required';
      }
      if (!values.newLanguage?.name?.length) {
        errors.newLanguage = 'Required';
      }
      if (!values.newCurrency) {
        (errors as any).newCurrency = 'Required';
      }

      return errors;
    },
    onSubmit: (values) =>
      mutation({
        oldProjectId: values.oldProjectId,
        newName: values.newName,
        newCurrency: values.newCurrency.code,
        newClientName: values.newClientName,
        newProtocol: values.newDomain.protocol,
        newHostName: values.newDomain.domain,
        languageId: values.newLanguage?.id,
        languageName: values.newLanguage?.name,
        locationId: !!values.newCity?.id
          ? values.newCity?.id
          : values.newCountry?.id === globalOption.id
            ? null
            : values.newCountry?.id,
        locationName: !!values.newCity?.id
          ? values.newCity?.name
          : values.newCountry?.id === globalOption.id
            ? null
            : values.newCountry?.name,
        fromLanguageName: values.fromLanguage?.name,
        fromLanguageId: values.fromLanguage?.id,
        serpLanguageId: values.newLanguage?.id,
        serpLanguageName: values.newLanguage?.name,
        serpLocationId: !!values.newCity?.id
          ? values.newCity?.id
          : values.newCountry?.id !== globalOption.id
            ? values.newCountry?.id
            : !!values.serpCity?.id
              ? values.serpCity?.id
              : values.serpCountry.id,
        serpLocationName: !!values.newCity?.id
          ? values.newCity?.name
          : values.newCountry?.id !== globalOption.id
            ? values.newCountry?.name
            : !!values.serpCity?.id
              ? values.serpCity?.name
              : values.serpCountry.name,
      }).then((result) => onSuccess(result)),
  });
}
